
//table表格组件头部标题统一管理

const tables_title_en = {
  account: 'account',
  name: 'name',
  project_name: 'project_name',
  patient_name: 'patient_name',
  dept: 'dept',
  position: 'position',
  phone: 'phone',
  age: 'age',
  create_time: 'create time',
  update_time: 'update time',
  status: 'status',
  assign_roles: 'assign roles',
  reset_password: 'reset password',
  birthday: 'birthday',
  password: 'password',
  repeat_password: 're-password',
  email: 'e-mail',
  sex: 'sex',
  male: 'male',
  female: 'female',
  label: 'label',
  follow_up_num: 'follow_up_num',
  //roles
  superior_role: 'superior role',
  alias: 'alias',
  sort: 'sort',
  su_project: 'su_project',
  //depts
  simple_name: 'simple name',
  full_name: 'full name',
  remarks: 'remarks',
  superior_name: 'superior name',
  //posts
  posts_name: 'position name',
  posts_code: 'position code',
  //dict type
  dict_type: 'dictionary type',
  sys_type: 'system type',
  non_sys_type: 'Non system type',
  enable: 'ENABLE',
  disable: 'DISABLE',
  type_name: 'type name',
  type_code: 'type code',
  sys_dict: 'system dictionary',
  dict_desc: 'dict description',
  yes: 'Y',
  no: 'N',
  dict_name: 'dictionary name',
  dict_code: 'dictionary code',
  super_dict: 'super dict',
  //menus
  level: 'level',
  menu: 'menu',
  menu_name: 'menu name',
  menu_code: 'menu code',
  parent_num: 'parent number',
  req_addr: 'request address',

  //login_log
  log_name: 'log name',
  user_name: 'user name',

  log_type: 'log type',
  log_class: 'class',
  log_method: 'method',
  exception_log: 'exception log',
  business_log: 'business log',

  //messages
  title: 'title',
  content: 'content',
  creater_name: 'creater name',

  //tenant
  tenant_name: 'tenant name',
  tenant_code: 'tenant code',
  update_name: 'updater name',
  database_name: 'database name',

  scale_name: 'Name of scale',
  model_issue_state: 'publish status',
  clinic: "clinic",
  state: "state",

  identity_ard: 'identity card',
  index_name: 'index name',
  recommend: 'recommend',
  inTime: 'inTime',
  follow_up_project: 'follow_up_project',
  more: 'more',
  principal:'principal',
  joinUnit:'joinUnit',
  joinDoctor:'joinDoctor',
  joinNumber:'joinNumber',
  followUpNumber:'followUpNumber',
  addRz:'addRz',
  addFollowUp:'addFollowUp',
  followUpStatus:'followUpStatus',

  mobile_phone_number: 'cell phone number',
  var_name: 'variable name',
  relevance_topic_or_index: 'Associate topics/indicators',
  relevance_topic_type: 'Associated topic type',
  common_model: 'Commonly used models',
  project_id: 'The project id',
  tag: 'label',
  version: 'Version',
  release_date: 'Release date',
  his_model_name: 'His model name',
  model_name: 'Model name',
  color: 'Color',

  //escorts
  escorting: 'Escorting',
  patients_served:'Patients served',
  affiliation: 'Affiliation',
  basic_information: 'Basic information',
  identity_card: 'Identity card',

  // patient
  visit_number: 'Visit number',
  department_bed: 'Department bed',
  escorts: 'Escorts',

}

export default tables_title_en



// WEBPACK FOOTER //
// ./src/common/lang/tables_title/tables_title_en.js